jQuery(function ($) {

  const storageKey   = 'open_from_app';
  const legacyKey   = 'open_from';
  const legacyVal   = 'app';
  const balancerFlag = 'open_from_app';

  function currentUrlHasAppFlag() {
    const params = new URLSearchParams(window.location.search);

    return (
      params.get(legacyKey) === legacyVal ||
      params.has(balancerFlag) ||
      $('#home_app').length > 0
    );
  }

  if (currentUrlHasAppFlag()) {
    sessionStorage.setItem(storageKey, 'true');
  }

  const isFromApp = sessionStorage.getItem(storageKey) === 'true';

  if (!isFromApp) {
    return;
  }

  /**
   * Protección para evitar mostrar la sección Terminal en app,
   * incluso si Varnish entrega por error la versión web cacheada.
   */
  $('.home__terminal video').each(function () {
    this.pause();
    this.removeAttribute('autoplay');
    this.removeAttribute('src');
    this.load();
  });

  $('.home__terminal').remove();

  /**
  * Oculta los items configurados para no mostrarse en app.
  */

  $('.js-hide-in-app').addClass('hide');

  if (!isFromApp) {
    return;
  }
  
  $('#header_home > .container, #header_general > .container').addClass('hide');
  $('#header_home #header_submenu, #header_general #header_submenu').addClass('header__menu--white');
  $('#header_general > .container').addClass('hide');
  $('#header_general #header_submenu').addClass('header__menu--white');
  $('#header_general #header_submenu > .container').addClass('hide-no-show-app');

  /**
   * Agrega open_from=app conservando los demás parámetros.
   */
  function addAppParameter(href) {
    if (!href) {
      return href;
    }

    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return href;
    }

    let url;

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return href;
    }

    // Solo links internos.
    if (url.origin !== window.location.origin) {
      return href;
    }

    url.searchParams.set(legacyKey, legacyVal);

    return url.toString();
  }

  /**
   * Links existentes y dinámicos.
   */
  $(document).on('click', 'a', function () {
    const $link = $(this);
    const href = $link.attr('href');
    const appHref = addAppParameter(href);

    if (appHref && appHref !== href) {
      $link.attr('href', appHref);
    }
  });

  /**
   * También modifica los links que ya existen,
   * útil para copiar dirección o abrir en otra pestaña.
   */
  $('a').each(function () {
    const $link = $(this);
    const href = $link.attr('href');
    const appHref = addAppParameter(href);

    if (appHref && appHref !== href) {
      $link.attr('href', appHref);
    }
  });

});